<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess"
            @delete-item="deleteType"
            @deleted="alertDeleted"
            @cancel="item = false"
            @error="alertError"
        ></view-item>

        <list-items
            v-else
            title="Activity Categories"
            :items="categories"
            @show-item="showItem"
            ref="table"
        >
            <b-row v-if="hasPermissionCreate">
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" v-if="hasPermissionCreate" @click="item = {}"
                        >Add Category</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'orderCategories',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            componentName:'Activity Category',
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('orderCategory/fetchAll')
        },

        showItem(id) {
            const item = this.categories.find(x => x.id === id)
            this.item = {...item}
        },

        alertSuccess(action, name) {
            this.genericToast(this.componentName,(action.charAt(0).toUpperCase()+action.slice(1)+'d'),'success',`"${name}" ${action}d successfully`)
            this.item = null
            this.doSearch()
        },

        alertDeleted(name){
            this.genericToast(this.componentName,'Deleted','success',`"${name}" deleted successfully`)
            this.item = null
            this.doSearch()
        },

        alertError(error,name){
            let message = error.message
            console.log('mmm', message)
            const interror = 'Internal Server Error'
            if (interror == error.message) {

            this.genericToast(`${this.componentName}`,'Duplicate','danger',`"${name}" is already in use. Please choose a different name`)

            }
        }
    },
}
</script>
<style></style>
